import Vue from 'vue'
import { brlPrice } from '@/filters/currency'
import {
  dateToHuman,
  datetimeToHuman,
  formatDate,
  brDate,
  dateToHour,
  dateToWeekday,
  dateToMonthday,
  minutesToHours
} from '@/filters/datetime'
import pluralize from '@/filters/pluralize'
import normalizeFlightNumber from '@/filters/normalizeFlightNumber'

Vue.filter('brlPrice', brlPrice)
Vue.filter('dateToHuman', dateToHuman)
Vue.filter('datetimeToHuman', datetimeToHuman)
Vue.filter('formatDate', formatDate)
Vue.filter('brDate', brDate)
Vue.filter('dateToHour', dateToHour)
Vue.filter('dateToWeekday', dateToWeekday)
Vue.filter('dateToMonthday', dateToMonthday)
Vue.filter('minutesToHours', minutesToHours)
Vue.filter('pluralize', pluralize)
Vue.filter('normalizeFlightNumber', normalizeFlightNumber)
